import { asContainer } from 'lib/container'

import { components } from 'components/DefaultMdxComponents'
import { Doc } from 'components/Layout'

import Content from './Content.mdx'

const content = Content({ components })

export const container = asContainer()({
	path: '/apis',
	title: 'APIs',
	authentication: { type: 'public' },
	Running: () => <Doc>{content}</Doc>,
})
